import { ShieldCheck, Camera, MailCheck } from "lucide-react";
import InstallButton from "@/components/InstallButton";

const Point = ({ icon: Icon, title, text }) => (
  <div className="flex gap-4">
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10"><Icon className="h-5 w-5 text-teal-300" /></div>
    <div><p className="font-display text-lg font-bold">{title}</p><p className="text-sm text-slate-300">{text}</p></div>
  </div>
);

export default function AuthLayout({ children }) {
  return (
    <div className="flex min-h-screen">
      <div className="relative hidden w-[46%] flex-col justify-between overflow-hidden bg-slate-900 p-12 text-white lg:flex">
        <img src="https://images.unsplash.com/photo-1642055514517-7b52288890ec?crop=entropy&cs=srgb&fm=jpg&q=70&w=1400" alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="relative flex items-center gap-3">
          <img src="/icon.svg" alt="" className="h-10 w-10" />
          <p className="font-display text-xl font-extrabold">InvoiceReconciler<span className="text-teal-300">.app</span></p>
        </div>
        <div className="relative max-w-md space-y-8">
          <h1 className="text-5xl font-extrabold leading-[1.05]">Every invoice.<br />Every credit.<br /><span className="text-teal-300">Accounted for.</span></h1>
          <div className="space-y-5">
            <Point icon={Camera} title="Snap it daily" text="Photograph invoices and credit claims as they arrive." />
            <Point icon={ShieldCheck} title="Reconcile monthly" text="Statements are checked line by line against what you hold." />
            <Point icon={MailCheck} title="Chase automatically" text="Wholesalers get queried and reminded until it's sorted." />
          </div>
        </div>
        <p className="relative text-xs text-slate-400">Staff accounts are approved by the owner.</p>
      </div>
      <div className="flex flex-1 flex-col items-center justify-center gap-6 bg-slate-50 p-4">
        <div className="flex items-center gap-3 lg:hidden">
          <img src="/icon.svg" alt="" className="h-10 w-10" />
          <p className="font-display text-xl font-extrabold" data-testid="auth-brand-name">InvoiceReconciler<span className="text-teal-600">.app</span></p>
        </div>
        {children}
        <InstallButton className="w-full max-w-sm lg:hidden" />
      </div>
    </div>
  );
}
